import { ItemList } from '../../orm'

class AdminSavedSearchesSubscriptionList extends ItemList {
    getEntityKey() {
        return "admin/saved_searches_subscription"
    }
}

export const adminSavedSearchesSubscriptionList = new AdminSavedSearchesSubscriptionList("admin_saved_searches_subscription__default")
